gender-checkboxes
  .checkboxes(class="{ props.type } { props.mobile ? 'sp' : 'pc' }")
    template(each="{(genderMaster, index) in state.genderMasters}")
      label
        template(if="{ props.type === 'in_modal' }")
          img(src="{checkboxOnIcon}" class="checkbox-icon { state.genders.includes(genderMaster.gender) ? '' : 'hidden' }")
          img(src="{checkboxOffIcon}" class="checkbox-icon { state.genders.includes(genderMaster.gender) ? 'hidden' : '' }")
        input(type="checkbox" onchange="{didChangeGender}" name="gn[{index}]" value="{ genderMaster.gender }"
              checked="{ state.existGender.includes(genderMaster.gender) }")
        | { genderMaster.text }
  style(type="scss").
    .checkboxes {
      display: flex;
      flex-wrap: wrap;
      &.in_sidebar {
        margin-top: 10px;
        label {
          width: 100%;
          border-top: 3px solid #e8e8e8;
          padding: 12px 8px;
          &:last-child {
            border-bottom: 3px solid #e8e8e8;
          }
          input {
            margin-right: 7px;
          }
        }
        &.pc {
          label {
            a {
              font-size: 12px;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        &.sp {
          margin-top: 16px;
          label {
            border-top-width: 2px;
            font-size: 15px;
            padding: 12px 13px;
            &:last-child {
              border-bottom-width: 2px;
            }
            input {
              margin-right: 4px;
            }
          }
        }
      }
      &.in_modal {
        row-gap: 11.25vw;
        label {
          width: 50%;
          color: #6c6c6c;
          font-size: 4.6875vw;
          font-weight: 700;
          display: flex;
          align-items: center;
          input {
            display: none;
          }
          .checkbox-icon {
            height: 6.40625vw;
            width: 6.40625vw;
            margin-right: 1.25vw;
            &.hidden {
              display: none;
            }
          }
        }
      }
    }
  script.
    import checkboxOnIcon from 'tags/smartsearch/checkbox_t.png'
    import checkboxOffIcon from 'tags/smartsearch/checkbox_f.png'
    import SmartsearchMaster from 'models/smartsearch-master.js'

    export default {
      checkboxOnIcon,
      checkboxOffIcon,
      onBeforeMount(props, state) {
        const masterData = new SmartsearchMaster()
        state.genderMasters = masterData.genderMasters
        state.genderValues = state.genderMasters.map(current => current.gender)

        state.existGender = []
        state.genders = []
      },
      didChangeGender() {
        const genderElements = this.root.querySelectorAll('.checkboxes input')
        const genders = Array.prototype.map.call(genderElements, (c) => {
          return c.checked ? c.value : ''
        }).filter(gender => gender.length > 0)
        const genderQuery = genders.join(',')
        this.update({
          genderQuery,
          genders
        })
        this.props.onUpdate(genderQuery)
      },
      initializeByExistQuery() {
        const result = (new RegExp('[?&]'+encodeURIComponent('gn')+'=([^&]*)')).exec(location.search)
        if(!result) return

        const existGender = decodeURIComponent(result[1]).split(',')
        this.update({
          existGender,
          genders: existGender
        })
      },
      urlFromValueWithFormData(value) {
        const queryKey = 'gn'
        if (!this.props.formdata) return

        const formDataObj = Object.fromEntries(Array.from(this.props.formdata.entries()))

        const currentValues = (this.state.genderQuery || '').split(',')
        if (!currentValues.includes(value)) {
          const values = Array.from(this.state.genderValues).filter( v => (currentValues.includes(v) || value == v) )
          formDataObj[queryKey] = values.join(',')
        }
        const formDataArray = Array.from(Object.entries(formDataObj)).sort((kv1, kv2) => {
          if (kv1 < kv2) { return -1 }
          else if (kv1 > kv2) { return 1 }
          else return 0
        })
        const url = '/watches/?' + formDataArray.filter( kv => !!kv[1] ).map( kv => kv[0] + '=' + kv[1] ).join('&')
        return url
      },
      onMounted(props, state) {
        this.initializeByExistQuery()
        this.update()
      },
    }
